module.exports = __webpack_public_path__ + "img/habilitacionNeL.569ae6fb.png";